import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import { trackPageview } from "@/lib/analytics";

/**
 * Emit a GA4 `page_view` on every SPA route change. Mounted once in Layout.
 * The analytics module itself guards for SSG / missing env / non-prod domain,
 * so this hook is always safe to call.
 */
export const usePageviews = (): void => {
  const { pathname } = useLocation();
  const { language } = useLanguage();

  useEffect(() => {
    if (typeof window === "undefined") return;
    const title = typeof document !== "undefined" ? document.title : "";
    trackPageview(pathname, title, language);
  }, [pathname, language]);
};
